import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useVehicles } from "../../Context/VehiclesContext";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import style from "../../assets/jss/disal-main/components/Modal";

const useStyles = makeStyles(style);

const ModalSuccess = () => {
  const classes = useStyles();
  const { openSave, setOpenSave } = useVehicles();

  const handleClose = () => {
    setOpenSave(false);
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={openSave}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500
      }}
    >
      <Fade in={openSave}>
        <div className={classes.paper} style={{ width: "500px" }}>
          <div className="modal-confirm">
            <h3>Guardado</h3>
            <p>El vehículo se guardó con éxito</p>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn-modal-salida"
              style={{ textDecoration: "underline", marginRight: "10px" }}
              onClick={handleClose}
            >
              OK
            </button>
          </div>
        </div>
      </Fade>
    </Modal>
  );
};

export default ModalSuccess;
